<template>
  <div>
    <v-layout row>
      <v-flex xs12 md6 offset-md3>
        <v-list three-line>
          <v-subheader>{{ this.$route.params.id }} agendas</v-subheader>
          <v-divider inset></v-divider>
          <small class="pl-6" v-if="!fetchAgendas.length">Nothing Here</small>
          <template v-for="(agenda, index) in fetchAgendas">
            <v-list-item :key="agenda._id">
              <v-list-item-content>
                <v-list-item-title>{{ agenda.title }}</v-list-item-title>
                <v-list-item-subtitle>{{
                  agenda.description
                }}</v-list-item-subtitle>
                <small v-if="['event', 'task'].includes(agenda.eventType)"
                  >Due
                  {{
                    agenda.eventType === "event"
                      ? moment().to(agenda.endTime)
                      : moment().to(agenda.startTime)
                  }}</small
                >
                <small
                  ><v-chip label outlined>{{ agenda.eventType }}</v-chip></small
                >
              </v-list-item-content>
              <v-list-item-icon>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      v-on="on"
                      v-if="canComplete"
                      @click="complete(agenda)"
                      color="green"
                      >done</v-icon
                    >
                  </template>
                  <span>Mark Done</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      v-on="on"
                      v-if="routeId === 'upcoming'"
                      @click="edit(agenda)"
                      color="green"
                      >edit</v-icon
                    >
                  </template>
                  <span>Edit</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" @click="deleteTodo(agenda)" color="red"
                      >delete</v-icon
                    >
                  </template>
                  <span>Delete</span>
                </v-tooltip>
              </v-list-item-icon>
            </v-list-item>
            <v-divider inset :key="index"></v-divider>
          </template>
        </v-list>
      </v-flex>
    </v-layout>
    <!-- dialog start -->
    <!-- <v-row justify="center">
      <v-dialog v-model="dialog" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Accept Notification</v-card-title>
          <v-card-text
            >For the application to work correctly, Notification must be enable.
            After closing this modal, please accept notification and don't
            forget to Add to Home Screen</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="notify">Ok</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row> -->
    <!-- dialog End -->

    <!-- snackBar Start -->
    <v-snackbar v-model="snackbar" :timeout="2000" top>
      {{ text }}
      <template v-slot:action="{ attrs }">
        <v-btn color="success" text v-bind="attrs" @click="snackbar = false"
          >Ok</v-btn
        >
      </template>
    </v-snackbar>
    <!-- snackBar End -->

    <!-- Edit dialog -->
    <v-dialog v-model="editAgenda" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Edit</v-card-title>
        <v-card-text>
          <v-form>
            <v-text-field type="text" label="title" v-model="formatAgenda.title" />
            <v-textarea label="description" v-model="formatAgenda.description" />
            <v-datetime-picker
              label="Start Time(YYYY-MM-DD 2h Hrs)"
              v-model="formatAgenda.startTime"
              v-if="['event', 'task'].includes(editDialog.eventType)"
              :text-field-props="textProps"
              :date-picker-props="dateProps"
            />
            <v-datetime-picker
              label="End Time(YYYY-MM-DD 2h Hrs)"
              v-if="editDialog.eventType === 'event'"
              v-model="formatAgenda.endTime"
              :text-field-props="textProps"
              :date-picker-props="dateProps"
            />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="orange darken-1" text @click="editAgenda = false"
            >Cancel</v-btn
          >
          <v-btn color="green darken-1" text @click="updateAgenda"
            >Update</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      dialog: false,
      editAgenda: false,
      snackbar: false,
      text: null,
      fetchAgendas: [],
      editDialog: {},
      installPromptEvent: null,
      textProps: {
        prependIcon: "event"
      },
      dateProps: {
        min: new Date().toISOString().split("T")[0]
      }
    };
  },
  methods: {
    agendaFunc() {
      let overdue = [];
      const currentTime = new Date().toISOString();
      this.$db.agendas
        .fetchRecords({
          $or: [
            {
              $and: [
                {
                  endTime: {
                    $lt: currentTime
                  }
                },
                {
                  status: "upcoming"
                }
              ]
            },
            {
              $and: [
                {
                  eventType: "task"
                },
                {
                  startTime: {
                    $lt: currentTime
                  }
                },
                {
                  status: "upcoming"
                }
              ]
            }
          ]
        })
        .then(result => {
          overdue = result.docs.map(agenda => {
            agenda.status = "overdue";
            return agenda;
          });
          this.$db.agendas.saveMany(overdue).then(() => {
            this.getAgenda();
          });
        });
    },
    getAgenda() {
      this.$db.agendas.fetchRecords({ status: this.routeId }).then(result => {
        this.fetchAgendas = result.docs;
        console.log(this.fetchAgendas);
      });
    },
    notify() {
      this.dialog = false;
      Notification.requestPermission().then(result => {
        if (result === "granted") {
          this.installPromptEvent.prompt();
          this.installPromptEvent.userChoice.then(choice => {
            choice.outcome === "accepted"
              ? this.installPromptEvent === null
              : "";
          });
        }
      });
    },
    complete(agenda) {
      agenda.status = "completed";
      this.$db.agendas.save(agenda).then(() => {
        this.text = "Congratulation, you completed a task";
        this.snackbar = true;
        this.getAgenda();
      });
    },
    edit(agenda) {
      this.editAgenda = true;
      this.editDialog = this.$copy(agenda);
      console.log(this.editDialog);
    },
    updateAgenda() {
      const agenda = this.$copy(this.formatAgenda);
      this.$db.agendas.save(agenda).then(() => {
        this.text = "Congratulation, you updated a task";
        this.snackbar = true;
        this.editAgenda = false;
        this.getAgenda();
        this.$store.dispatch('updateAgenda', agenda);
      });
    },
    deleteTodo(agenda) {
      const choice = confirm("Are you sure you want to delete");
      if (choice) {
        agenda._deleted = true;
        this.$db.agendas.save(agenda).then(() => {
          this.text = "Deleted successfully";
          this.snackbar = true;
          this.$store.dispatch('updateAgenda', agenda);
          this.getAgenda();
        });
      }
    }
  },
  computed: {
    formatAgenda() {
      const formattedAgenda = {
        ...this.editDialog
      }
      if(this.editDialog.eventType === "event") {
        formattedAgenda.startTime = new Date(this.editDialog.startTime)
        formattedAgenda.endTime = new Date(this.editDialog.endTime)
      }
      else if (this.editDialog.eventType === "task") {
        formattedAgenda.startTime = new Date(this.editDialog.startTime)
      }
      return formattedAgenda
    },
    ...mapGetters({
      getTodos: "getTodos",
      isComplete: "isComplete",
      getUpcomingTodoTime: "getUpcomingTodoTime"
    }),
    ...mapActions(["loadTodo", "checkLeastUpcomingTime"]),
    routeId() {
      return this.$route.params.id;
    },
    isOnline() {
      return navigator.onLine;
    },
    canComplete() {
      return ["upcoming", "overdue"].includes(this.routeId);
    }
  },
  watch: {
    isOnline(status) {
      console.log(status);
      if (!status) return;
      // this.$store.dispatch("scheduleOffine");
    },
    $route() {
      // this.getTodos = this.$store.dispatch("loadTodo");
      this.agendaFunc();
    },
    getUpcomingTodoTime() {
      this.$store.dispatch("checkLeastUpcomingTime");
    }
  },
  mounted() {
    this.agendaFunc();
    // this.getTodos = this.$store.dispatch("loadTodo");
  },
  created() {
    window.addEventListener("beforeinstallprompt", event => {
      event.preventDefault();
      this.installPromptEvent = event;
    });
    if (
      "Notification" in window &&
      Notification.permission !== "denied" &&
      Notification.permission !== "granted"
    ) {
      this.dialog = true;
    }
  }
};
</script>
